var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index" },
    [
      _c(
        "el-container",
        [
          _c("el-main", [
            _c("div", { staticClass: "main" }, [
              _c(
                "div",
                { staticClass: "main-left" },
                [_c("form-item-config")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "main-middle" }, [
                _c(
                  "div",
                  { staticClass: "button-top" },
                  [
                    _c("index-button-group", {
                      on: {
                        submit: _vm.saveTemplate,
                        saveDomain: _vm.saveDomain
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "drop-wrap" },
                  [_c("form-draggable-container")],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "main-right" },
                [_c("form-item-setting")],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c22d3bb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c22d3bb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/RiceIndex/src/RiceIndex.vue
// module id = null
// module chunks = 